// gameService.js
import request from './request';

const gameService = {
  getAll: (params) => request.get('admin/game/games', { params }),
  delete: (id) => request.delete(`admin/game/games/${id}`),
  edit: (id, updatedData) => request.put(`admin/game/games/${id}`, updatedData),
  add: (newGame) => request.post('admin/game/games', newGame),
};

export default gameService;
